

export const buttonsConfig = {
  0: {
    id: "zero",
    symbol: "0",
    colSpan: 2,
    rowSpan: 1,
    key: [
      "0"
    ],
  },
  1: {
    id: "one",
    symbol: "1",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "1"
    ],
  },
  2: {
    id: "two",
    symbol: "2",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "2"
    ],
  },
  3: {
    id: "three",
    symbol: "3",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "3"
    ],
  },
  4: {
    id: "four",
    symbol: "4",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "4"
    ],
  },
  5: {
    id: "five",
    symbol: "5",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "5"
    ],
  },
  6: {
    id: "six",
    symbol: "6",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "6"
    ],
  },
  7: {
    id: "seven",
    symbol: "7",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "7"
    ],
  },
  8: {
    id: "eight",
    symbol: "8",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "8"
    ],
  },
  9: {
    id: "nine",
    symbol: "9",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "9"
    ],
  },
  add: {
    id: "add",
    symbol: "+",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "+"
    ],
  },
  subtract: {
    id: "subtract",
    symbol: "-",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "-"
    ],
  },
  divide: {
    id: "divide",
    symbol: String.fromCharCode(247), //Divide
    colSpan: 1,
    rowSpan: 1,
    key: [
      "/"
    ],
  },
  multiply: {
    id: "multiply",
    symbol: "x",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "*",
      "x"
    ],
  },
  equal: {
    id: "equals",
    symbol: "=",
    colSpan: 1,
    rowSpan: 2,
    key: [
      "Enter"
    ],
    },
  dot: {
    id: "decimal",
    symbol: ".",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "."
    ],
  },
  AC: {
    id: "clear",
    symbol: "AC",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "Delete"
    ],
  },
  DEL: {
    symbol: "DEL",
    colSpan: 1,
    rowSpan: 1,
    key: [
      "Backspace"
    ],
  }
}

export  const buttonsOrder = [
    "AC", "DEL", "divide", "multiply",
    7, 8, 9, "subtract",
    4, 5, 6,  "add",
    1, 2 ,3 , "equal",
    0, "dot"
];


// WEBPACK FOOTER //
// ./src/configApp.js